export default __webpack_public_path__ + "static/media/Photo 8 - MR - Mauvaise protection.0cfd6969.png";